import Vue from 'vue'
import { Component, Prop, PropSync } from 'vue-property-decorator'
import { getGUID, openPopup } from '@appbase/util'
import { createEventBus, removeEventBus } from '@appbase/util/eventBus'
import api from '../../api'

export interface TWishContainerOptionItem {
  id: number
  name: string
  height: string
  items?: orgmap.TWishContainerItem[]
}

export interface TWishContainerOptions {
  addableDept: boolean
  single: boolean
  containers: TWishContainerOptionItem[]
}

export interface TWishItemPropsOptions {
  props: string[]
}

const EVENT_ORG_POPUP = '$reserve/org/popup'

@Component({})
export default class RecipientField extends Vue {
  @Prop({ type: Boolean, default: false }) readOnly!: boolean
  @Prop({ type: String, default: '' }) fieldGuid!: string
  @Prop({ type: String, default: '' }) placeholder!: string
  @Prop({ type: Boolean, default: false }) single!: false
  @PropSync('recipients', { type: Array }) recipientsSync!: orgmap.UserItem[]

  onSearching: boolean = false
  searchText: string = ''
  autoCompletesModel: orgmap.UserItem[] = []

  created() {
    createEventBus(window, `${EVENT_ORG_POPUP}/${this.fieldGuid}`, this.handlePopupResult)
  }

  beforeDestroy() {
    removeEventBus(window, `${EVENT_ORG_POPUP}/${this.fieldGuid}`, this.handlePopupResult)
  }

  handlePopupResult(data: any) {
    console.log('popupResult', data)
    if (data && data.length > 0) {
      var popupResult: any[] = data[0].items
      popupResult.forEach((p) => {
        if (!(this.recipientsSync.findIndex((r) => p.id === r.id) >= 0)) {
          this.recipientsSync.push({
            id: p.id,
            deptName: p.deptName,
            displayName: p.name,
            email: p.value,
            titleName: p.title,
            comCode: '',
            deptCode: p.deptCode,
            parentDeptCode: '',
            personCode: p.id,
            selected: false,
          })
        }
      })
    }
  }

  onKeyDown(e: KeyboardEvent) {
    if (e.key.toLocaleLowerCase() === 'enter') {
      this.searchAction()
    } else if (e.key.toLocaleLowerCase() === 'backspace') {
      if (this.recipientsSync.length > 0 && this.searchText.length == 0) {
        this.recipientsSync.splice(this.recipientsSync.length - 1, 1)
      }
    }
  }

  onKeyBlur() {
    var _this = this
    setTimeout(() => {
      _this.autoCompletesModel = []
    }, 150)
  }

  setAutoCompleteBoxPos() {
    var inpElem = this.$refs.inpText as HTMLInputElement
    var inpElemRect = inpElem.getBoundingClientRect()
    var ulElem = this.$refs.ulCompleteBox as HTMLUListElement

    if (ulElem) {
      ulElem.style.top = `${inpElemRect.top - 10}px`
      ulElem.style.left = `${inpElem.offsetLeft + 55}px`
    }
  }

  searchAction() {
    var searchText = this.searchText
    if (searchText.trim().length < 2) return

    api.orgmap
      .searchOrg(
        {
          query: searchText,
          size: 10,
        },
        'FL'
      )
      .then((res) => {
          // 임직원은 조직도 버튼을 통해서만 추가 가능
        // if (res.items.length == 1) {
        //   var rec = res.items[0]
        //   this.handleUserPush(rec)
        // } else if (res.items.length >= 2) {
        //   this.setAutoCompleteBoxPos()
        //   this.autoCompletesModel = res.items
        // } else 
        if (searchText && searchText.length > 0) {
          var pattern =
            /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/
          if (pattern.test(searchText)) {
            this.handleUserPush({
              displayName: searchText,
              email: searchText
            } as any)
          }
        }
      })
  }

  autoCompleteSelect(user: orgmap.UserItem) {
    this.handleUserPush(user)
  }

  handleUserPush(user: orgmap.UserItem) {
    // if (!(this.recipientsSync.findIndex((m) => m.id === user.id) >= 0)) {
    //   this.recipientsSync.push(user)
    // }
    if (!(this.recipientsSync.findIndex((m) => m.email === user.email) >= 0)) {
      this.recipientsSync.push(user)
    }

    this.searchText = ''
    this.autoCompletesModel = []
  }

  onDeleteClick(user: orgmap.UserItem) {
    var idx = this.recipientsSync.findIndex((m) => m.id === user.id)

    if (idx >= 0) {
      this.recipientsSync.splice(idx, 1)
    }
  }

  onOrgmapClick() {
    const orgmapOption: TWishContainerOptions = {
      addableDept: true,
      single: this.single,
      containers: [{ id: 0, name: '선택한 사람', height: '1' }],
    }

    const props: TWishItemPropsOptions = {
      props: ['id', 'name', 'personCode', 'deptName', 'deptCode', 'title'],
    }

    openPopup(
      'reserveRecipients',
      '/orgmap',
      { event: `${EVENT_ORG_POPUP}/${this.fieldGuid}`, option: orgmapOption, props },
      { width: 1024, height: 768, isFrame: this.isTeams }
    )
  }

  getDisplayName(user: orgmap.UserItem) {
    if (!user.titleName && !user.deptName) {
      return user.displayName
    } else {
      return `${user.displayName} ${user.titleName} (${user.deptName})`
    }
  }
}
